module.exports = "/static/assets/cf8f0e51849e00182a45b5bfd3a3e95a.png";